export class Point
{
   
    constructor (
        public x: number = 0,
        public y: number = 0
    )
    {}
}